export default ngModule => {

    ngModule.directive('basicPageHeader', (AonConfig) => {
        return {
            restrict: 'E',
            scope: {
                'title': '@',
            },
            template: `
            <div class="step-progress basic-page">
            <ul>
                <li></li>
                <li><div class="step-content"><span class="step-title">{{title}}</span></div></li>
                <li></li>
            </ul>
            </div>
            `,
            link: (scope, element, attrs, ngModel) => {

            }
        };
    });

    /*
    Directive to allow basic page content to contain javascript-y things, add here as required.
    */
    ngModule.directive('basicPageContent', (AonConfig, $interpolate, $sce, $timeout) => {
        return {
            restrict: 'E',
            scope: {
                content: '=',
            },
            template: `<section ng-bind-html="trustedContent"></section>`,
            link: (scope) => {
                scope.corporate = AonConfig.corporate;
                scope.trustedContent = scope.content && $sce.trustAsHtml($interpolate(scope.content)(scope));
                $timeout(() => {
                    $('ol > li').each(function (i) {
                        var heading = $(this).find('h2');
                        var content = $(this).find('div.collapse').remove();
                        heading.wrapInner('<a/>').find('a').attr('href', '').click(function (ev) {
                            content.slideToggle();
                            $('div.collapse:not(#' + content.attr('id') + ')').slideUp();
                            ev.preventDefault();
                        });
                        $(this).append(content);
                    });
                    $('div.collapse').hide();
                });
            }
        };
    });
}



// WEBPACK FOOTER //
// ./src/directives/basic-page.js